import fetcher from '@/services/fetcher'
import type { SocialWinner } from '@/types'
import { createDateTimeComparator } from '@/utils/date-time-utils'
import { defineStore } from 'pinia'

type SocialWinnersStoreState = {
  winners: Map<string, SocialWinner>
  fetchPromise: Promise<Array<SocialWinner>> | null
}

export const useSocialWinnersStore = defineStore('social-winners', {
  state: (): SocialWinnersStoreState => ({
    winners: new Map<string, SocialWinner>(),
    fetchPromise: null,
  }),

  getters: {
    winnersArray(): Array<SocialWinner> {
      return Array.from(this.winners.values())
        .filter((winner) => winner.enabled !== false)
        .sort(createDateTimeComparator('won_at', 'desc'))
    },
  },

  actions: {
    async fetchSocialWinners(): Promise<void | Array<SocialWinner>> {
      // return the fetch promise to prevent multiple calls
      if (this.fetchPromise) {
        return this.fetchPromise
      }

      if (this.winners.size) {
        return this.winnersArray
      }

      this.fetchPromise = fetcher
        .get<SocialWinner>('/data/true-north-social-winners.json', false, {
          key: 'id',
          map: this.winners,
        })
        .then(() => this.winnersArray)
        .finally(() => {
          // allow a retry if the fetch failed (the populated map caches success)
          this.fetchPromise = null
        })

      return this.fetchPromise
    },
  },
})
